import {connect} from 'react-redux';
import {type AnyAction, bindActionCreators, type Dispatch} from 'redux';

import {showActionsDropdownPulsatingDot} from 'selectors/actions_menu';
import {setActionsMenuInitialisationState} from 'mattermost-redux/actions/preferences';

import {type DispatchFunc, type GetStateFunc} from 'mattermost-redux/types/actions';
import {removePost, type ExtendedPost} from 'mattermost-redux/actions/posts';
import {getCurrentTeamId, getTeamById} from 'mattermost-redux/selectors/entities/teams';
import {makeGetCommentCountForPost} from 'mattermost-redux/selectors/entities/posts';

import {get} from 'mattermost-redux/selectors/entities/preferences';
import {getConfig} from 'mattermost-redux/selectors/entities/general';

import {type Post} from 'mattermost-redux/types/posts';

import {type GlobalState} from 'types/store';

import {closeRightHandSide} from 'actions/views/rhs';
import {emitShortcutReactToLastPostFrom} from 'actions/post_actions';
import {Preferences} from 'utils/constants';
import {shouldShowDotMenu, shouldShowActionsMenu} from 'utils/post_utils';
import {getSelectedPostCard} from 'selectors/rhs';
import {getShortcutReactToLastPostEmittedFrom, getOneClickReactionEmojis} from 'selectors/emojis';
import {getIsPostBeingEdited} from '../../../selectors/posts';

import {isThreadOpened} from 'features/threads/selectors/is_thread_opened';

import PostInfo from './post_info';

type OwnProps = {
    post: Post;
};

function removePostAndCloseRHS(post: ExtendedPost) {
    return (dispatch: DispatchFunc, getState: GetStateFunc) => {
        const state = getState() as GlobalState;
        if (isThreadOpened(state, post.id)) {
            dispatch(closeRightHandSide());
        }
        return dispatch(removePost(post));
    };
}

function makeMapStateToProps() {
    const getReplyCount = makeGetCommentCountForPost();
    let emojis: any[] = [];

    return (state: GlobalState, ownProps: OwnProps) => {
        const selectedCard = getSelectedPostCard(state);
        const config = getConfig(state);
        const channel = state.entities.channels.channels[ownProps.post.channel_id];
        const channelIsArchived = channel ? channel.delete_at !== 0 : null;
        const enableEmojiPicker = config.EnableEmojiPicker === 'true' && !channelIsArchived;
        const teamId = channel?.team_id || getCurrentTeamId(state);
        const team = getTeamById(state, teamId);
        const teamName = team?.name;

        const shortcutReactToLastPostEmittedFrom = getShortcutReactToLastPostEmittedFrom(state);
        const showActionsMenuPulsatingDot = showActionsDropdownPulsatingDot(state);

        const oneClickReactionsEnabled =
            get(
                state,
                Preferences.CATEGORY_DISPLAY_SETTINGS,
                Preferences.ONE_CLICK_REACTIONS_ENABLED,
                Preferences.ONE_CLICK_REACTIONS_ENABLED_DEFAULT,
            ) === 'true';
        if (oneClickReactionsEnabled) {
            emojis = getOneClickReactionEmojis(state);
        }

        return {
            teamId,
            teamName,
            channelType: channel?.type,
            channelName: channel?.name,
            isFlagged: get(state, Preferences.CATEGORY_FLAGGED_POST, ownProps.post.id, null) != null,
            isMobile: state.views.channel.mobileView,
            isCardOpen: selectedCard && selectedCard.id === ownProps.post.id,

            isPostBeingEdited: getIsPostBeingEdited(state, ownProps.post.id),
            enableEmojiPicker,
            isArchived: channelIsArchived,
            shouldShowDotMenu: channel && shouldShowDotMenu(state, ownProps.post, channel),
            shouldShowActionsMenu: shouldShowActionsMenu(state, ownProps.post),
            shortcutReactToLastPostEmittedFrom,
            hasReplies: getReplyCount(state, ownProps.post) > 0,
            showActionsMenuPulsatingDot,
            oneClickReactionsEnabled,
            recentEmojis: emojis,
        };
    };
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return {
        actions: bindActionCreators(
            {
                removePost: removePostAndCloseRHS,
                emitShortcutReactToLastPostFrom,
                setActionsMenuInitialisationState,
            },
            dispatch,
        ),
    };
}

export default connect(makeMapStateToProps, mapDispatchToProps)(PostInfo);
